import { EffectsMapObject } from "dva";
import { ReducersMapObject } from "redux";
import { freeze } from "immer";
import { CoreEffects, CoreReducers, crypt } from "@reco-m/core";
import { app } from "@reco-w/core-ui";

import { Namespaces as commonNamespaces } from "@reco-w/common-models";
import { loginSMSService, authService, authAccountHttpService, addMemberService } from "@reco-w/auth-service";

import { Namespaces } from "./common";

export namespace registerModel {
    export const namespace = Namespaces.register;

    export const state: any = freeze(
        {
            confirmDirty: false,
            isTrue: false, // 用户协议是否勾选
        },
        !0
    );

    export type StateType = typeof state;
    export const reducers: ReducersMapObject = {
        ...CoreReducers,
        initState() {
            return state;
        },
    };
    export const effects: EffectsMapObject = {
        ...CoreEffects,
        /**
         * 发送验证码
         */
        *sendVerifyCode({ delay, data, callback }, { call }) {
            const cleardelay = delay();
            try {
                yield call(loginSMSService.getLoginCode, {
                    response_type: "mobile",
                    client_id: server.apiKey!.apiKey,
                    scope: "",
                    ...data,
                });
            } catch (e) {
                cleardelay();
                callback!(e.errmsg);
            }
        },
        /**
         * 获取用户信息
         */
        *getAccounts({ data, callback }, { call, put }) {
            try {
                const accounts = yield call(authService.getPaged, {
                    ...data,
                });
                callback(accounts.Items);
                yield put({ type: "input", data: { accounts: accounts.Items } });
            } catch (e) {}
        },
        /**
         * 提交
         */
        *submit({ error, callback }, { call, put, select }) {
            try {
                yield put({ type: "input", data: { isSubmit: true } });

                const data = yield select(({ register }) => register),
                    { phone, code, password } = data;

                const cryptPassword = crypt(password);

                const token = yield call(loginSMSService.loginNew, { encryMode: server["rsa"]?.enable ? 1 : 0, username: phone, code: code, password: cryptPassword });

                loginSMSService.refreshToken(token, server.auth!.autoRefreshToken);

                yield yield put({ type: `${commonNamespaces.memberCommon}/refreshCurrentUser` });

                yield put({ type: "config" });

                callback(token.uid);
            } catch (e) {
                yield put({ type: "input", data: { isSubmit: false } });
                yield call(error, e.errmsg);
            }
        },

        *config({}, { select, put, call }) {
            try {
                yield yield put({ type: `${commonNamespaces.memberCommon}/getCertify`, isRefreshUser: true });
                const memberCommonState: any = yield select((state) => state[commonNamespaces.memberCommon]);
                const user = memberCommonState.user;
                const currentUser = user.currentUser;
                if (currentUser.id) {
                    // 登录添加会员
                    yield call(addMemberService.addMember, currentUser.id);
                }
            } catch (error) {}
        },
        /**
         * 快速获取用户信息
         */
        *getUserByMobile({ error, params }, { call, put }) {
            try {
                const result = yield call(authAccountHttpService.getSampleUser, { ...params, openPlatform: -1 });
                if (result.items.length > 0) {
                    yield put({ type: "input", data: { help: "手机号已注册！" } });
                } else {
                    yield put({ type: "input", data: { validateStatus: "success", help: "", isPhoneOK: true, phone: params.mobile } });
                }
            } catch (e) {
                yield call(error, "getUserByMobile：" + e.errmsg);
            }
        },
    };
}
app.model(registerModel);
